module.exports = {"340103001":"亳州路街道","340103002":"双岗街道","340103003":"杏林街道","340103004":"海棠街道","340103005":"杏花村街道","340103006":"逍遥津街道","340103009":"三孝口街道","340103012":"四里河街道","340103100":"大杨镇","340103200":"三十岗乡","340103400":"庐阳工业区（林店街道）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340103.json
// module id = 1036
// module chunks = 0